import {ILayout} from './LayoutModels'

// Metronic 8.1 demo1 "app" layout: fixed left sidebar (minimizable) + header carrying the page
// title. Navigation lives entirely in the sidebar, so the header menu and the toolbar row are off.
export const DefaultLayoutConfig: ILayout = {
  layoutType: 'dark-sidebar',
  main: {
    componentName: 'main',
    type: 'default',
    pageBgWhite: false,
  },
  app: {
    general: {
      componentName: 'general',
      evolution: true,
      layoutType: 'default',
      mode: 'light',
      rtl: false,
      primaryColor: '#009EF7',
      pageBgWhite: false,
      pageWidth: 'default',
    },
    header: {
      componentName: 'header',
      display: true,
      default: {
        container: 'fluid',
        containerClass: 'd-flex align-items-stretch justify-content-between',
        fixed: {
          desktop: true,
          mobile: true,
        },
        content: 'page-title',
        menu: {
          display: false,
          iconType: 'font',
        },
      },
    },
    sidebar: {
      componentName: 'sidebar',
      display: true,
      default: {
        class: 'flex-column',
        push: {
          header: true,
          toolbar: true,
          footer: true,
        },
        drawer: {
          enabled: true,
          attributes: {
            'data-kt-drawer': 'true',
            'data-kt-drawer-name': 'app-sidebar',
            'data-kt-drawer-activate': '{default: true, lg: false}',
            'data-kt-drawer-overlay': 'true',
            'data-kt-drawer-width': '250px',
            'data-kt-drawer-direction': 'start',
            'data-kt-drawer-toggle': '#kt_app_sidebar_mobile_toggle',
          },
        },
        fixed: {
          desktop: true,
        },
        minimize: {
          desktop: {
            enabled: true,
            default: false,
            hoverable: true,
          },
        },
        menu: {
          iconType: 'font',
        },
      },
    },
    toolbar: {
      componentName: 'toolbar',
      display: false,
    },
    pageTitle: {
      componentName: 'page-title',
      display: true,
      breadCrumb: true,
      // The page's sub-title (<PageDescription>) is not shown in the top bar.
      description: false,
      direction: 'row',
    },
    content: {
      componentName: 'content',
      // stock's pages are laid out for the fixed-width container (hrm uses fluid).
      container: 'fixed',
    },
    footer: {
      componentName: 'footer',
      display: false,
    },
    pageLoader: {
      componentName: 'page-loader',
      type: 'none',
    },
  },
  scrolltop: {
    componentName: 'scrolltop',
    display: true,
  },
}
